import { APICore } from '../../helpers/api/apiCore';
import * as URL from '../../helpers/api/apiEndPoint';

const api = new APICore();

function Vendor(data): any {
    let { search, limit, pages } = data?.data;
    return api.get(`${URL.VENDOR_GET}?search=${encodeURIComponent(search)}&limit=${limit}&page=${pages}`);
}

function createVendor(params: any): any {
    const { data } = params;
    return api.create(URL.VENDOR_POST, data);
}

function updateVendor(params: any): any {
    const { data } = params;
    return api.update(URL.VENDOR_UPDTAE, data);
}
function deleteVendor(params: any): any {
    const { data } = params;
    return api.delete(`${URL.VENDOR_DELETE}?_id=${data?.id}`);
}
function uploadClientData(params: any): any {
    const { data } = params;
    return api.create(URL.CLIENT_DATA_UPLOAD, data);
}

function account(params: any): any {
    const { search, limit, pages } = params.data;
    return api.get(`${URL.ACCOUNT_GET}search=${encodeURIComponent(search)}&limit=${limit}&page=${pages}`);
}

function createAccount(params: any): any {
    const { data } = params;
    return api.create(URL.ACCOUNT_POST, data);
}
function updateAccount(params: any): any {
    const { data } = params;
    return api.update(URL.ACCOUNT_UPDTAE, data);
}
function deleteAccount(params: any): any {
    const { data } = params;
    return api.delete(`${URL.ACCOUNT_DELETE}?_id=${data?.id}`);
}
function uploadAccountData(params: any): any {
    const { data } = params;
    return api.create(URL.ACCOUNT_DATA_UPLOAD, data);
}
export { Vendor, createVendor, updateVendor, deleteVendor, account, createAccount, updateAccount, deleteAccount, uploadAccountData, uploadClientData };
